"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.searchPublicSubjects = exports.getPublicSubject = exports.getPublicSubjects = exports.deleteSubjectRelation = exports.postSubjectRelation = exports.putSubjectOrganization = exports.putSubjectAccessibility = exports.deleteSubjectPermission = exports.postSubjectPermission = exports.putSubjectAction = exports.delSubject = exports.postSubject = exports.putSubject = exports.getSubject = exports.getSubjects = void 0;

var root_1 = require("./root");

var common_1 = require("../common");

var subjectsAuthorizedPath = root_1.lmsAuthorized + '/subjects/';
var subjectsPublicPath = root_1.lmsPublic + '/subjects/';

var getSubjects = function getSubjects(authentication, queryParameters) {
  return common_1.get(authentication, subjectsAuthorizedPath, queryParameters);
};

exports.getSubjects = getSubjects;

var getSubject = function getSubject(authentication, id) {
  return common_1.get(authentication, subjectsAuthorizedPath + id);
};

exports.getSubject = getSubject;

var putSubject = function putSubject(authentication, subject) {
  return common_1.put(authentication, subjectsAuthorizedPath + subject.id, subject);
};

exports.putSubject = putSubject;

var postSubject = function postSubject(authentication, pos) {
  return common_1.post(authentication, subjectsAuthorizedPath, pos);
};

exports.postSubject = postSubject;

var delSubject = function delSubject(authentication, id) {
  return common_1.del(authentication, subjectsAuthorizedPath + id);
};

exports.delSubject = delSubject;

var putSubjectAction = function putSubjectAction(authentication, id, action, data) {
  return common_1.putSub(authentication, subjectsAuthorizedPath, id, action, data);
};

exports.putSubjectAction = putSubjectAction;

var postSubjectPermission = function postSubjectPermission(authentication, id, permission) {
  return common_1.postPermission(authentication, subjectsAuthorizedPath, id, permission);
};

exports.postSubjectPermission = postSubjectPermission;

var deleteSubjectPermission = function deleteSubjectPermission(authentication, id, permissionId) {
  return common_1.deletePermission(authentication, subjectsAuthorizedPath, id, permissionId);
};

exports.deleteSubjectPermission = deleteSubjectPermission;

var putSubjectAccessibility = function putSubjectAccessibility(authentication, id, accessibility) {
  return common_1.putAccessibility(authentication, subjectsAuthorizedPath, id, accessibility);
};

exports.putSubjectAccessibility = putSubjectAccessibility;

var putSubjectOrganization = function putSubjectOrganization(authentication, id, organizationId) {
  return common_1.putEntityOrganization(authentication, subjectsAuthorizedPath, id, organizationId);
};

exports.putSubjectOrganization = putSubjectOrganization;

var postSubjectRelation = function postSubjectRelation(authentication, id, relation) {
  return common_1.postRelation(authentication, subjectsAuthorizedPath, id, relation);
};

exports.postSubjectRelation = postSubjectRelation;

var deleteSubjectRelation = function deleteSubjectRelation(authentication, id, relationId) {
  return common_1.deleteRelation(authentication, subjectsAuthorizedPath, id, relationId);
};

exports.deleteSubjectRelation = deleteSubjectRelation;

var getPublicSubjects = function getPublicSubjects(authentication, queryParameters) {
  return common_1.get(authentication, subjectsPublicPath, queryParameters);
};

exports.getPublicSubjects = getPublicSubjects;

var getPublicSubject = function getPublicSubject(authentication, id) {
  return common_1.get(authentication, subjectsPublicPath + id);
};

exports.getPublicSubject = getPublicSubject;

var searchPublicSubjects = function searchPublicSubjects(authentication, queryParameters) {
  return common_1.get(authentication, subjectsPublicPath + 'search', queryParameters);
};

exports.searchPublicSubjects = searchPublicSubjects;